import { createRouter, createWebHistory } from 'vue-router';
import Quasar from 'quasar/src/vue-plugin.js';;

import store from '@/store';
import i18n from '@/helpers/i18n';
import dayjs from '@/helpers/dayjs';

import SignIn from '@/views/SignIn.vue';
import ResetPassword from '@/views/ResetPassword.vue';
import Account from '@/views/Account.vue';
import Dashboard from '@/views/Dashboard.vue';
import DoctorsIndex from '@/views/DoctorsIndex.vue';
import DoctorsShow from '@/views/DoctorsShow.vue';

const routes = [
  {
    path: 'sign-in',
    name: 'SignIn',
    component: SignIn,
    meta: {
      layoutName: 'SignIn',
    },
  },
  {
    path: 'reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: {
      layoutName: 'SignIn',
    },
  },
  {
    path: 'account',
    name: 'Account',
    component: Account,
  },
  {
    path: '',
    name: 'Dashboard',
    component: Dashboard,
  },
  {
    path: 'doctors',
    name: 'DoctorsIndex',
    component: DoctorsIndex,
  },
  {
    path: 'doctors/:doctorId',
    name: 'DoctorsShow',
    component: DoctorsShow,
  },
];

const defaultLocale = 'en';

const i18nRoutes = [
  ...routes.map((route) => {
    return {
      ...route,
      path: route.path === '/' ? '/' : `/${route.path}`,
    };
  }),
];

const router = createRouter({
  base: process.env.VUE_APP_ROUTER_BASE_URL,
  history: createWebHistory(process.env.VUE_APP_ROUTER_BASE_URL),
  routes: i18nRoutes,
});

router.beforeEach((to, from, next) => {
  i18n.global.locale =
    store.getters['account/info']?.user.locale || defaultLocale;
  i18n.locale = store.getters['account/info']?.user.locale || defaultLocale;
  dayjs.locale(store.getters['account/info']?.user.locale || defaultLocale);

  let langName = 'en-GB';

  if (store.getters['account/info']?.user.locale === 'it') {
    langName = 'it';
  } else if (store.getters['account/info']?.user.locale === 'es') {
    langName = 'es';
  }

  if (langName !== Quasar.lang.isoName) {
    import('quasar/lang/' + langName).then((lang) =>
      Quasar.lang.set(lang.default)
    );
  }

  if (!to.meta?.layoutName && !store.getters['account/info']) {
    return next({ name: 'SignIn' });
  }

  next();
});

export default router;
